export default {
    meta: {
        title: '拓店宝-亚瑟士-机会点详情'
    }
};
